import React from 'react';
import PropTypes from 'prop-types';
import ReactECharts from 'echarts-for-react';
import './ebiosTheme';

const EChart = ({ option, height = 300, loading = false, onEvents, notMerge = false }) => {
  return (
    <ReactECharts
      theme="ebios"
      option={option}
      style={{ height, width: '100%' }}
      opts={{ renderer: 'canvas' }}
      showLoading={loading}
      autoResize
      onEvents={onEvents}
      notMerge={notMerge}
    />
  );
};

EChart.propTypes = {
  option: PropTypes.object.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool,
  onEvents: PropTypes.object,
  notMerge: PropTypes.bool
};

export default EChart;
